export default __webpack_public_path__ + "static/media/light.37ac16b0.svg";